// import React, { useEffect, useState } from "react";

import Header from "../../common/Header";
import style from "./index.module.css";
// import profileImage from "../../assets/dashboard/Anita Photo.png";
import { Box } from "@mui/material";
import moment from "moment/moment";
import React, { useEffect, useState } from "react";
import { BsFillPersonFill } from "react-icons/bs";
import { useSelector } from "react-redux";
import { ReactComponent as MoneyIcon } from "../../assets/dashboard/moneyIcon.svg";
import { ReactComponent as ShareGroupIcon } from "../../assets/dashboard/shareGroup.svg";
import { ReactComponent as VisaTransactionsIcon } from "../../assets/dashboard/visaTransactions.svg";
import {
  getVisaLancerDashboard,
  getVisaLancerRewardsSummary,
} from "../../services/services";

const Dashboard = () => {
  const [profileData, setProfileData] = useState();
  const [visaLancerData, setVisaLancerData] = useState();
  // const userDetails = JSON.parse(localStorage.getItem("userInfo"));
  const userDetails = useSelector((state) => state.userProfile?.result?.data);

  const Create_Date = moment(new Date(Number(userDetails?.created_on))).format(
    "DD MMM YYYY"
  );

  const getVisaeroDashboardData = async () => {
    try {
      const request = await getVisaLancerDashboard();
      const response = await request.data;
      setProfileData(response?.data);
    } catch (error) {
      console.log(error);
    }
  };
  const getVisaLancerRewardsSummaryData = async () => {
    try {
      const request = await getVisaLancerRewardsSummary();
      const response = await request.data;
      setVisaLancerData(response?.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getVisaeroDashboardData();
    getVisaLancerRewardsSummaryData();
  }, []);
  return (
    <Box className={style.container}>
      <Header header="Dashboard" />
      <Box className={style.userDetail_container}>
        {/* <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "1rem",
          }}
        >
          <Box className={style.profile_img}>
            {userDetails?.profile_signed_url ? (
              <img
                src={userDetails?.profile_signed_url}
                key={new Date().valueOf()}
              />
            ) : (
              <BsFillPersonFill style={{ margin: 0, objectFit: "cover" }} />
            )}
          </Box>
        </Box> */}
        <div className={style.userNameSection}>
          <h4 className={style.userName}>
            {userDetails?.first_name} {userDetails?.last_name}
          </h4>
          <p className={style.userDesc}>
            VisaLancer since&nbsp;
            <font style={{ color: "black" }}>{Create_Date && Create_Date}</font>
          </p>
        </div>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "1rem",
            // flexWrap: "wrap",
            justifyContent: "center",
            margin: "1rem 0rem",
            width: "100%",
            padding: "0 15px ",
          }}
        >
          <Box
            className={style.user_boxContainer}
            style={{ borderColor: "#31B311" }}
          >
            <div className={style.user_box_label}>
              Lifetime Earning
              <MoneyIcon />
            </div>
            <div
              className={style.user_box_drawer}
              style={{ backgroundColor: "black" }}
            />
            <p className={style.user_box_field}>
              {profileData?.lifetime_earning}
            </p>
          </Box>

          <Box
            className={style.user_boxContainer}
            style={{ borderColor: "#198BF4" }}
          >
            <div className={style.user_box_label}>
              My Registered Users
              <ShareGroupIcon />
            </div>
            <div
              className={style.user_box_drawer}
              style={{ backgroundColor: "black" }}
            />
            <p className={style.user_box_field}>{profileData?.connected_user}</p>
          </Box>

          <Box
            className={style.user_boxContainer}
            style={{ borderColor: "#198BF4" }}
          >
            <div className={style.user_box_label}>
              Visa Transactions
              <VisaTransactionsIcon />
            </div>
            <div
              className={style.user_box_drawer}
              style={{ backgroundColor: "black" }}
            />
            <p className={style.user_box_field}>{profileData?.visa}</p>
          </Box>

          {/* <Box
            className={style.user_boxContainer}
            style={{ borderColor: "#198BF4" }}
          >
            <p className={style.user_box_label}>Conversion</p>
            <h1
              className={style.user_box_drawer}
              style={{ backgroundColor: "black" }}
            ></h1>
            <p className={style.user_box_field}>{profileData?.conversion}</p>
          </Box> */}
        </Box>
        {visaLancerData?.length > 0 && (
          <div className={style.content_section}>
            <p className={style.description}>
              Dear partner, <br />
              Please find below visa transaction details of your customers. Due
              to data privacy reasons, we are unable to share name of the
              customers.
            </p>
            <div className={style.yearlyData}>
              {visaLancerData?.map((rewardObj, idx) => (
                <div className={style.monthRow} key={idx}>
                  <h4>{rewardObj?.monthYear || ""}</h4>
                  <div
                    className={style.tableGrid}
                    // style={{ borderBottom: "1px solid #C2C2C2" }}
                  >
                    {/* Header */}
                    <div className={`${style.cell} ${style.header}`}>Sr No</div>
                    <div
                      style={{ textAlign: "center" }}
                      className={`${style.cell} ${style.header}`}
                    >
                      Reference Number
                    </div>
                    <div className={`${style.cell} ${style.header}`} style={{textAlign: "end"}}>
                      Earnings
                    </div>

                    {/* Row */}
                    {rewardObj?.applications?.map((application, indx) => (
                      <React.Fragment key={indx}>
                        <div className={style.cell}>
                          {(indx + 1).toString().padStart(2, "0")}
                        </div>
                        <div
                          className={style.cell}
                          style={{ textAlign: "center" }}
                        >
                          {application?.application_reference_code || ""}
                        </div>
                        <div className={style.cell} style={{textAlign: "end"}}>
                          {application?.reward_value || ""}
                        </div>
                      </React.Fragment>
                    ))}

                    {/* Footer */}
                    <div className={style.footerLabel}>Total</div>
                    <div className={style.footerValue}>
                      {rewardObj?.totalRewardValue}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </Box>
    </Box>
  );
};

export default Dashboard;
